const BASE_URL = 'https://www.hostelworld.com';
const UNSAFE_EXT_FOR_RAPI = [
  '.js',
  '.css',
  '.png',
  '.jpg',
  '.jpeg',
  '.gif',
  '.svg',
  '.webp',
  '.ico',
  '.map',
  '.woff',
  '.woff2',
  '.ttf',
  '.eot',
  '.otf',
  '.json',
  '.xml',
  '.yml',
  '.yaml',
];
const UNSAFE_DIRS_FOR_RAPI = [
  '_nuxt',
  '.git',
  '.well-known',
  '.env',
  'wp-content',
  'wp-includes',
  'wp-admin',
  'wp-json',
];

export function checkIfFile(url) {
  url = new URL(url, BASE_URL);
  return url.pathname.split('/').at(-1).indexOf('.') > 0;
}

export function isSafeDirForRedirectionApi(url) {
  const fullUrl = new URL(url, BASE_URL);
  const pathParts = fullUrl.pathname.split('/') || [];
  return pathParts.filter((part) => UNSAFE_DIRS_FOR_RAPI.includes(part)).length === 0;
}

export function isSafePathForRedirectionApi(url) {
  if (!isSafeDirForRedirectionApi(url)) {
    return false;
  }

  const fullUrl = new URL(url, BASE_URL);
  const pathParts = fullUrl.pathname.split('/');

  const lastPart = pathParts[pathParts.length - 1]?.split('.') || [];

  const partExtension = lastPart.length > 1 ? `.${lastPart[lastPart.length - 1]}` : '';

  return !UNSAFE_EXT_FOR_RAPI.includes(partExtension);
}

/**
 * Build URLSearchParams from a Nuxt / Vue Router `route.query` object.
 * Array values become repeated keys (e.g. `groupAgeRange=3&groupAgeRange=4`).
 * `new URLSearchParams(query)` stringifies arrays as comma-separated values and breaks consumers that expect repeated keys
 *
 * @param {Record<string, string | string[] | undefined | null> | undefined | null} query
 * @returns {URLSearchParams} Mutable search params ready for `toString()` or further edits.
 */
export function buildUrlSearchParamsFromRouteQuery(query) {
  const params = new URLSearchParams();

  if (!query || typeof query !== 'object') {
    return params;
  }

  for (const key of Object.keys(query)) {
    const value = query[key];

    if (value === undefined || value === null) {
      continue;
    }

    if (Array.isArray(value)) {
      for (const item of value) {
        if (item !== undefined && item !== null) {
          params.append(key, String(item));
        }
      }
      continue;
    }

    params.append(key, String(value));
  }

  return params;
}
